// Centralized branding configuration for Vim Sensei
// All branding-related strings should be defined here

export const branding = {
  // Core identity
  name: 'Vim Sensei',
  nameUppercase: 'VIM SENSEI',
  domain: 'vimsensei.com',
  handle: '@vimsensei',
  year: '2026',

  // Taglines
  tagline: 'master vim with guided practice',
  shortTagline: 'become a vim master',

  // Page title
  pageTitle: 'Vim Sensei',

  // Sidebar
  sidebarHeading: 'Training Path',

  // localStorage keys (use kebab-case, include brand)
  storagePrefix: 'vim-sensei',
  completedLessonsKey: 'vim-sensei-completed-lessons',

  // Status line
  statusBadge: 'VIM SENSEI',
} as const;

export type Branding = typeof branding;
